// extracted by mini-css-extract-plugin
export default {"titlePage":"TitlePage_style_titlePage__H+wFT","rotate":"TitlePage_style_rotate__PDAEG"};